module.exports = {
        srcSet: __webpack_public_path__ + "static/media/phone-500.bc352583.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/phone-500.bc352583.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/phone-500.bc352583.webp",
        toString: function(){return __webpack_public_path__ + "static/media/phone-500.bc352583.webp"},
        
        width: 500,
        height: 500
      }